import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { SitesStorageService } from "@/services/v2/sites/storage";
import { onMounted, provide } from "vue";
import { useSitesStore, useUsersStore } from "@/stores/v2";
import {  } from "@/stores/v2";


export default /*@__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

provide("appName", "Finput")

const init = async () => {
    const userStore = useUsersStore();
    userStore.setFromLocalStorage();

    if (userStore.isLoggedIn) {
        const activeSite = await SitesStorageService.getActiveSite();
        if (activeSite && activeSite.key) {
            return useSitesStore().setActiveSite(activeSite.key);
        }
    }
};

onMounted(init);

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createBlock(_component_router_view))
}
}

})